'use client'
import { cn } from '../../helpers/utils.js'
import { withLayout } from '../../shared/Styles.js'
import { Text } from '../../components/index.js'

interface FootChargerType extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    title: string
    text: string
  }
}

const FootCharger = ({ data, className, ...rest }: FootChargerType) => {
  const { title, text } = data

  return (
    <>
      <div {...rest} className={className}>
        <div>
          <Text
            html={title}
            className="desktop:text-[18px] text-[16px] font-bold leading-[1.4] text-[#6D6D6F] [&_span]:text-[#080A0F]"
          />
        </div>
        <div className="mt-[24px]">
          <Text html={text} className="text-[14px] leading-[1.4] text-[#3D3D3F] [&_*_strong]:!font-bold" />
        </div>
      </div>
    </>
  )
}

export default withLayout(FootCharger)
